import type { CustomVariable, ContractSection, ContractTemplate } from './types';

export interface ExportedTemplate {
  version: '1';
  exportedAt: string;
  template: {
    name: string;
    title: string | null;
    customVariables: CustomVariable[];
    sections: ContractSection[];
  };
}

export function downloadJSON(data: any, filename: string) {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function createTemplateExport(template: ContractTemplate): ExportedTemplate {
  return {
    version: '1',
    exportedAt: new Date().toISOString(),
    template: {
      name: template.name,
      title: template.title,
      customVariables: template.customVariables,
      sections: template.sections.map(s => ({
        ...s,
        templateId: undefined as any,
      })),
    },
  };
}
